import React, {Component} from "react";
import {USER_ROLES} from "../../../helpers/constants";
import {connect} from "react-redux";
import {Card, CardBody, CardTitle, Input} from "reactstrap";
import {I18n} from "../../../I18n/components/statistics";
import {fetchStores} from "../../../actions/storesActions";
import QRCode from "qrcode.react";
import {fetchUsers} from "../../../actions/usersActions";

class TrackGeoActivity extends Component {

    constructor(props) {
        super(props);
        this.state = {
            airAlarm: false,
            comment: null
        };
    }

    componentDidMount() {
        const {company} = this.props;
        (async () => {
            await this.props.fetchStores({
                companyId: company.id
            });
        })()
    }

    getUrl = () => {
        const {company, store, userId} = this.props;
        const {airAlarm, comment} = this.state;
        if (!store) {
            return '';
        }
        let url = `https://packageassistant.com/geoActivity.html` +
            `?companyId=${company.id}&salesPointId=${store.id}&userId=${userId}&airAlarm=${airAlarm}`;
        if (store.operatorIds && store.operatorIds.length === 1) {
            url += `&operatorCompanyId=${store.operatorIds[0]}`;
        }
        if (comment) {
            url += `&comment=${encodeURIComponent(comment)}`
        }
        if (store.latitude && store.longitude) {
            url += `&storeLatitude=${store.latitude}&storeLongitude=${store.longitude}`;
        }
        return url;
    }

    onInputChange = event => {
        const name = event.target.name;
        const value = event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value;
        this.setState({[name]: value});
    };

    getContent = () => {
        const {airAlarm, comment} = this.state;
        const {loading, lang, store} = this.props;
        if (loading) {
            return <div className="loading">Loading...</div>;
        }
        if (!store) {
            return <h4 className="text-danger">{I18n[lang].geoActivity.userHasToBeConnectedToSingleStore}</h4>;
        }
        if (store.operatorIds && store.operatorIds.length > 1) {
            return <h4 className="text-danger">{I18n[lang].geoActivity.storeMustHaveMaximumOneOperator}</h4>;
        }
        const url = this.getUrl();
        return (
            <div>
                <h4 className="m-4">{I18n[lang].geoActivity.checkInOutTitle}</h4>
                <QRCode className="m-4" size="150" value={url}/>
                <div className="d-flex justify-content-center align-items-center m-4">
                    <input
                        style={{width: "20px", height: "20px"}}
                        type="checkbox"
                        id="airAlarm"
                        name="airAlarm"
                        checked={airAlarm}
                        onChange={this.onInputChange}
                    />
                    <label htmlFor="airAlarm" className="ml-2 my-0 font-18">{I18n[lang].geoActivity.airAlarmWithDescription}</label>
                </div>
                <Input
                    className="w-75 mx-auto my-4 font-18"
                    type="textarea"
                    rows="3"
                    maxLength="100"
                    placeholder={I18n[lang].geoActivity.commentPlaceholder}
                    id="comment"
                    name="comment"
                    value={comment}
                    onChange={this.onInputChange}
                />
                <div><a className="btn btn-lg btn-primary m-4" target="_blank"
                        href={url}>{I18n[lang].geoActivity.open}</a></div>
            </div>)
    }

    render() {
        return (
            <div>
                <Card>
                    <CardTitle className="mb-0 p-3 border-bottom bg-light">
                        <div>
                            <i className="mdi mdi-qrcode-scan mr-2"/>
                            Check-in/out
                        </div>
                    </CardTitle>

                    <CardBody className="p-4 text-center">
                        {this.getContent()}
                    </CardBody>
                </Card>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchStores: query => dispatch(fetchStores(query)),
        fetchUsers: query => dispatch(fetchUsers(query)),
    };
};

const mapStateToProps = state => ({
    loading: state.storesReducer.loading,
    authority: state.currentUser.roles[0].authority || USER_ROLES.GUEST,
    company: state.companiesReducer.companies.length > 1 ? {id: 1} : state.companiesReducer.companies[0],
    store: state.storesReducer.stores.length > 1 ? {id: 1} : state.storesReducer.stores[0],
    userId: state.currentUser.userId,
    lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(TrackGeoActivity)


// WEBPACK FOOTER //
// ./src/components/Statistics/GeoActivity/TrackGeoActivity.js